import { render, staticRenderFns } from "./InstallContract.vue?vue&type=template&id=498225be&"
import script from "./InstallContract.vue?vue&type=script&lang=js&"
export * from "./InstallContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports